import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { DiagnosisDetails } from 'src/app/core/Models/interfaces/master-management/diagnosisDetails';
import { Pagination } from 'src/app/core/Models/interfaces/pagination';
import { UserService } from 'src/app/core/Services/user.service';
import { ToasterService } from 'src/app/shared/services/toaster.service';
import { CustomValidation } from 'src/app/shared/validators/customValidators';
import { DiagnosisCodeService } from '../../services/diagnosis-code.service';
import { AllerrgyCodeService } from '../../services/allerrgyCode.service';
import { AllergyDetails } from 'src/app/core/Models/interfaces/master-management/allergyDetails';
import { AllergyHeader } from 'src/app/core/Models/interfaces/master-management/headers/allergy-header';
import { DiagnosisHeader } from 'src/app/core/Models/interfaces/master-management/headers/diagnosis-header';

@Component({
  selector: 'app-master-management-detail-view',
  templateUrl: './master-management-detail-view.component.html',
  styleUrls: ['./master-management-detail-view.component.css']
})
export class MasterManagementDetailViewComponent implements OnInit {
  private page_limit: number = 10;
  public versionForm!: FormGroup;
  public page!: string;
  public diaganosisVersionId!: number;
  public allergyVersionId!: number;
  public page_no: number = 1;
  public totalCount!: number;
  public fetchingInProgress: boolean = false;
  public versionDetailsHeader = {
    activeFrom: '',
    expiredOn: '',
    version: ''
  };
  public diagnosisDetailsList: DiagnosisDetails[] = [];
  public allergyDetailsList: AllergyDetails[] = [];



  constructor(
    private userService: UserService,
    private toasterAndLoader: ToasterService,
    private router: Router,
    private route: ActivatedRoute,
    private diagnosisCodeService: DiagnosisCodeService,
    private allergyCodeService: AllerrgyCodeService
  ) {
    this.versionForm = new FormGroup({
      code: new FormControl(null),
      filterByName: new FormControl(null),
    }, CustomValidation.formNotNull);
  }

  private getRequestId(): void {
    this.route.paramMap.subscribe((params) => {
      const diaganosisVersionId = params.get('diaganosisVersionId');
      const allergyVersionId = params.get('allergyVersionId');
      if (diaganosisVersionId && +diaganosisVersionId > 0) {
        this.diaganosisVersionId = +diaganosisVersionId;
      }
      if (allergyVersionId && +allergyVersionId > 0) {
        this.allergyVersionId = +allergyVersionId;
      }

    });

    const url = this.router.url;
    if (url.includes('/diagnosis-detail-view')) {
      this.page = 'diagnosis-detail-view';
    } else {
      this.page = 'allergy-detail-view'
    }
  }

  private getVersionDetails(): void {
    this.fetchingInProgress = true
    this.toasterAndLoader.isLoaderEnable(true);
    if (this.page == 'diagnosis-detail-view' && this.diaganosisVersionId ) {
      const payLoad = {
        diaganosisVersionId: this.diaganosisVersionId,
        per_page: this.page_limit,
        page: this.page_no,
        sort: '',
        diaganosisCode: this.versionForm.value.code || null,
        diaganosis: this.versionForm.value.filterByName || null,
      }
      this.diagnosisCodeService.getDiagnosisDetails(payLoad).subscribe({
        next: (response) => {
          this.diagnosisDetailsList = response?.data?.data;
          this.setVersionDetailsHeader(response.data.header_details);
          this.totalCount = response?.data?.total;
          this.toasterAndLoader.isLoaderEnable(false);
          this.fetchingInProgress = false;

        },
        error: (error) => {
          this.toasterAndLoader.isLoaderEnable(false);
          this.fetchingInProgress = false;
        },
      })
    }
    else if (this.page == 'allergy-detail-view' && this.allergyVersionId ) {
      const payLoad = {
        allergyVersionId: this.allergyVersionId,
        per_page: this.page_limit,
        page: this.page_no,
        sort: '',
        allergyCode: this.versionForm.value.code || null,
        allergy: this.versionForm.value.filterByName || null,
      }
      this.allergyCodeService.getAllergyCodeDetails(payLoad).subscribe({
        next: (response) => {
          this.allergyDetailsList = response?.data?.data;
          this.setVersionDetailsHeader(response.data.header_details);
          this.totalCount = response?.data?.total;
          this.toasterAndLoader.isLoaderEnable(false);
          this.fetchingInProgress = false;

        },
        error: (error) => {
          this.toasterAndLoader.isLoaderEnable(false);
          this.fetchingInProgress = false;
        },
      })
    }
  }

  private setVersionDetailsHeader(header: DiagnosisHeader | AllergyHeader): void {
    if (this.page == 'diagnosis-detail-view') {
      const head = header as DiagnosisHeader;
      this.versionDetailsHeader.version = head?.diaganosisVersion ? head.diaganosisVersion : '';
      this.versionDetailsHeader.activeFrom = head?.diaganosisVersionActiveFrom ? head.diaganosisVersionActiveFrom : '';
      this.versionDetailsHeader.expiredOn = head?.diaganosisVersionExpiredOn ? head.diaganosisVersionExpiredOn : '';
    }
    else if (this.page == 'allergy-detail-view') {
      const head = header as AllergyHeader;
      this.versionDetailsHeader.version = head?.allergyVersion ? head.allergyVersion : '';
      this.versionDetailsHeader.activeFrom = head?.allganosisVersionActiveFrom ? head.allganosisVersionActiveFrom : '';
      this.versionDetailsHeader.expiredOn = head?.allganosisVersionExpiredOn ? head.allganosisVersionExpiredOn : '';
    }
  }

  ngOnInit() {
    this.getRequestId();
  }

  public currentPageDetail(event: Pagination): void {
    if (event) {
      this.page_no = event.button_no;
      this.page_limit = event.item_per_page;
    }
    this.getVersionDetails();
  }

  public filterOnClick(): void {
    this.page_no = 1;
    this.getVersionDetails();
  }

  public resetFilter(): void {
    this.page_no = 1
    this.versionForm.reset();
    this.getVersionDetails();
  }

  public back(): void {
    if (this.diaganosisVersionId) {
      this.router.navigate(['master-management', 'diagnosis-management']);
    }
    if (this.allergyVersionId) {
      this.router.navigate(['master-management', 'allergy-management']);
    }
  }

  public checkPermission(perName: string): boolean {
    return this.userService.getPermissions(perName);
  }

}
